import DrmDetector from '@javascripts/utils/drm_detector';

export default class DrmBlocker {
  constructor({ tech } = {}) {
    this._tech = tech;
    this._supportedDrm = [];
    this._keySysConfig = [{
      'initDataTypes': ['cenc'],
      'videoCapabilities': [{ 'contentType': 'video/mp4;codecs="avc1.4D401E"' }]
    }];
    this._keySystems =
      ['com.microsoft.playready',
        'com.widevine.alpha',
        'com.apple.fairplay',
        'com.apple.fps'];
    this._blockerCountdown = 5000;
    this._drmDetector = new DrmDetector();
  }

  tech() {
    return this._tech;
  }

  supportedDrm() {
    return this._supportedDrm;
  }

  keySysConfig() {
    return this._keySysConfig;
  }

  keySystems() {
    return this._keySystems;
  }

  blockerCountdown() {
    return this._blockerCountdown;
  }

  drmDetector() {
    return this._drmDetector;
  }

  init() {
    this.onPlayerBuffer();
  }

  onPlayerBuffer() {
    this.tech().one('bufferstart', () => {
      this.playerBufferHandler();
    });
  }

  playerBufferHandler() {
    this.checkDrmSupport();
    this.determineBlocker();
  }

  checkDrmSupport() {
    DrmDetector.keySystems.forEach((keySystem) => {
      this.checkDrmEach(keySystem);
    });
  }

  checkDrmEach(keySystem) {
    this.drmDetector().drmCheck(keySystem).then((response) => {
      if (response) {
        this._supportedDrm.push(keySystem);
        console.log(keySystem + ' supported');
      };
    });
  }

  determineBlocker() {
    setTimeout(() => {
      if (this.supportedDrm().length == 0) {
        this.tech().error(5);
      }
    }, this.blockerCountdown());
  };
}